// @ts-check
import { BREAKPOINTS, BREAKPOINT_SIZES } from 'tradera-constants/breakpoints';

/**
 * Return breakpoint label for given width
 *
 * @param {int} [width]
 * @returns {string|null}
 */
function getCurrentBreakpoint(width = window.innerWidth) {
    for (let { min, max, name } of Object.values(BREAKPOINT_SIZES)) {
        if (width >= min && width <= max) {
            return name;
        }
    }
    return null;
}

/**
 * Check if current width is within a given breakpoint range
 *
 * @param {string} name
 * @param {int} [width]
 * @returns {boolean}
 */
function isBreakpoint(name, width = window.innerWidth) {
    return (
        width >= BREAKPOINT_SIZES[name].min &&
        width <= BREAKPOINT_SIZES[name].max
    );
}

/**
 * Check if current width is in a given breakpoint range or below
 *
 * @param {string} name
 * @param {int} [width]
 * @returns {boolean}
 */
function isBreakpointOrLower(name, width = window.innerWidth) {
    return width <= BREAKPOINT_SIZES[name].max;
}

/**
 * Check if current width is in a given breakpoint range or above
 *
 * @param {string} name
 * @param {int} [width]
 * @returns {boolean}
 */
function isBreakpointOrHigher(name, width = window.innerWidth) {
    return width >= BREAKPOINT_SIZES[name].min;
}

/**
 * Check if current breakpoint is classified as desktop (large and above)
 *
 * @returns {boolean}
 */
function isDesktop() {
    return isBreakpointOrHigher(BREAKPOINTS.LG);
}

/**
 * Check if current breakpoint is classified as tablet (medium)
 *
 * @returns {boolean}
 */
function isTablet() {
    return isBreakpoint(BREAKPOINTS.MD);
}

/**
 * Check if current breakpoint is classified as mobile (small and below)
 *
 * @returns {boolean}
 */
function isMobile() {
    return isBreakpointOrLower(BREAKPOINTS.SM);
}

export {
    BREAKPOINTS,
    BREAKPOINT_SIZES,
    getCurrentBreakpoint,
    isBreakpoint,
    isBreakpointOrLower,
    isBreakpointOrHigher,
    isDesktop,
    isTablet,
    isMobile
};
